{
    "yes": "Si",
    "no": "No",
    "confirm": "Conferma",
    "apply": "Applica",
    "cancel": "Annulla",
    "show": "Mostra",
    "hide": "Nascondi",
    "send": "Invia",
    "close": "Chiudi",
    "edit": "Modifica",
    "delete": "Elimina",
    "loading": "Caricamento",
    "expand": "Espandi",
    "collapse": "Riduci",
    "fullscreenEnter": "Passa a schermo intero",
    "fullscreenExit": "Esci da schermo intero",
    "center": "Centro",
    "bottom": "In basso",
    "hidden": "Nascosto",
    "day": "Giorno",
    "month": "Mese",
    "year": "Anno",
    "dayPlaceholder": "GG",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "AAAA",
    "createdAt": "Data creazione",
    "selected": "Selezionati",
    "page": "pagina",
    "actions": "Azioni",
    "next": "Successivo",
    "all": "Tutti",
    "copied": "Copiato!",
    "today": "Oggi",
    "yesterday": "Ieri",
    "date": "Data di nascita",
    "last_7_days": "Ultimi 7 giorni",
    "last_30_days": "Ultimi 30 giorni",
    "previous": "Precedente",
    "placeholder": "Fai una domanda",
    "copy": "Copia",
    "copyRawCode": "Copia codice sorgente",
    "copyToClipboard": "Copia negli appunti",
    "showOriginalText": "Mostra originale",
    "showTranslatedText": "Mostra traduzione",
    "exactPosition": "Posizione esatta",
    "uncertain": "Incertezza",
    "question": "Domanda",
    "nothingFound": "Nessun risultato",
    "venue": "Luogo",
    "searchVenue": "Cerca luogo...",
    "privacyPolicy": "Informativa sulla privacy",
    "popularLanguages": "Popolari",
    "allLanguages": "Tutte le lingue",
    "memoriBlockedTitle": "Bloccato",
    "memoriBlockedUntil": "Agente bloccato fino al {{date}}",
    "memoriBlockedAnon": "Attualmente \"{{name}}\" non può rispondere, torna qui il {{date}}",
    "memoriBlockedReasonExceedChats": "perchè ha superato la soglia mensile di chat ammesse.",
    "memoriBlockedGiverHelper": "Puoi sempre gestirlo in qualità di amministratore, ma altri utenti non potranno interrogarlo.",
    "generatedByAI": "Risposta generata da IA, può talvolta generare informazioni non corrette",
    "reasoning": "Ragionamento...",
    "whyThisAnswer": "Perché questa risposta?",
    "whyThisAnswerHelper": "Questa risposta è stata generata automaticamente da un'intelligenza artificiale sulla base di questi contenuti verificati.",
    "receiverLabel": "Assegnato a",
    "missingData": "Informazioni mancanti",
    "completionsEnabled": "IA evoluta, può rispondere con risposte generate automaticamente che talvolta potrebbero contenere informazioni non corrette",
    "completionProviderDown": "Questo agente è integrato con una IA generativa di {{provider}}, ma al momento non è disponibile. Riprova più tardi.",
    "completionProviderMajorOutage": "Questo agente è integrato con una IA generativa di {{provider}}, ma al momento non è disponibile. Non sarà possibile utilizzare questa funzionalità finché il servizio non viene ripristinato.",
    "completionProviderPartialOutage": "Questo agente è integrato con una IA generativa di {{provider}}, ma sta riscontrando interruzioni parziali. Alcune funzionalità potrebbero non essere disponibili o funzionare in modo non ottimale.",
    "completionProviderDegraded": "Questo agente è integrato con una IA generativa di {{provider}}, ma sta funzionando più lentamente del normale. Le risposte potrebbero richiedere più tempo o essere meno precise.",
    "completionProviderFallbackName": "un provider esterno",
    "completionProviderCheckStatusPage": "Vedi pagina di stato",
    "boardOfExperts": "Gruppo di esperti",
    "birthDate": "Data di nascita",
    "birthDateHelper": "Ti chiediamo la data di nascita esclusivamente per abilitare o disabilitare le funzionalità che hanno restrizioni in base all'età",
    "underage": "Devi avere almeno {{age}} anni per registrarti.",
    "underageTwinSession": "Devi avere almeno {{age}} anni per interagire con questo agente.",
    "errorFetchingSession": "Errore durante il caricamento della sessione",
    "errorGettingReferralURL": "Errore durante il caricamento del riferimento",
    "errorReopeningSession": "Errore durante il riapertura della sessione",
    "ageVerification": "Verifica dell'età",
    "ageVerificationText": "Per interagire con questo agente, devi aver almeno {{minAge}} anni.",
    "nsfw": "NSFW: Questo agente contiene contenuti per adulti",
    "deepThought": "Pensiero profondo",
    "deepThoughtHelper": "Pensiero Profondo è una funzionalità avanzata delle AI che ti consentirà di poter sfruttare a pieno le tue conversazioni mantenendo memoria delle stesse. Le AI con Pensiero Profondo possono darti informazioni adattandosi a te e alle cose che condividerete insieme.",
    "deepThoughtDisclaimerTitle": "Pensiero profondo abilitato",
    "deepThoughtDisclaimer": "Pensiero Profondo è una funzionalità avanzata delle AI che ti consentirà di poter sfruttare a pieno le tue conversazioni mantenendo memoria delle stesse. Le AI con Pensiero Profondo possono darti informazioni adattandosi a te e alle cose che condividerete insieme.",
    "deepThoughtPreDisclaimerUnlogged": "Accedi per abilitare Pensiero Profondo.",
    "deepThoughtPreDisclaimerNotAllowed": "Pensiero Profondo è disabilitato poiché non hai acconsentito al suo utilizzo, puoi cambiare la tua scelta in qualsiasi momento nelle impostazioni del tuo account.",
    "notEnoughCredits": "L'autore di questo agente non ha abbastanza crediti per rispondere alla tua domanda.",
    "confirmDialog": {
        "title": "Confermi di voler lasciare questa pagina?",
        "message": "Le modifiche non salvate andranno perse."
    },
    "knownFacts": {
        "title": "Fatti noti",
        "description": "Dettagli delle informazioni condivise tra te e {{memoriName}}",
        "type": "Tipo",
        "typeShortTerm": "Breve termine",
        "typeLongTerm": "Lungo termine",
        "typeHelper": "Tipi:\n- Breve termine: questo fatto noto è sempre utilizzato durante le conversazioni\n- Lungo termine: questo fatto noto è utilizzato durante le conversazioni solo se rilevante per la domanda corrente",
        "text": "Testo",
        "deleteSuccess": "Fatto noto eliminato",
        "deleteConfirmTitle": "Elimina il fatto noto",
        "deleteConfirmMessage": "Confermi di voler eliminare questo fatto noto?",
        "deleteSelectedConfirmTitle": "Elimina i fatti noti selezionati",
        "deleteSelectedConfirmMessage": "Confermi di voler eliminare i fatti noti selezionati?"
    },
    "auth": {
        "title": "Autenticazione",
        "useRecoveryTokens": "Utilizza i token di recupero",
        "tokens": "Token",
        "addToken": "Aggiungi token",
        "usePassword": "Utilizza la password",
        "invalidCredentials": "Credenziali non valide",
        "atLeast": "Almeno"
    },
    "widget": {
        "instruct": "Istruisci",
        "test": "Prova",
        "sound": "Suono",
        "position": "Preferenze posizione",
        "settings": "Impostazioni",
        "share": "Condividi",
        "shareChat": "Condividi chat",
        "sendOnKeypress": "Premi Invio per inviare",
        "sendOnClick": "Clicca su Invia",
        "boardOfExperts": "Board di esperti",
        "showExpertsInTheBoard": "Mostra esperti in questa board",
        "expertsInTheBoard": "Esperti in questa board",
        "goToIntegrationsToCustomizeAvatar": "Per personalizzare l'avatar, vai a Condividimi e configura la pagina pubblica"
    },
    "exportChatHistory": {
        "exportPDF": "Esporta chat come PDF",
        "exporting": "Esportazione in corso...",
        "empty": "Nessuna cronologia chat da esportare",
        "pdfNotSupported": "L'esportazione PDF non è supportata in questo browser",
        "success": "Chat esportata in PDF con successo",
        "error": "Impossibile esportare la chat in PDF. Riprova."
    },
    "write_and_speak": {
        "micButtonPopover": "Premi il pulsante per parlare",
        "micButtonPopoverListening": "Premi il pulsante per smettere di parlare",
        "pageInstructExplanation": "Per insegnarmi nuove cose clicca sul pulsante ISTRUISCIMI per cominciare",
        "pageTryMeExplanation": "Per parlare con me clicca sul pulsante INIZIAMO per cominciare",
        "pagePrivacyExplanation": "Le conversazioni sono visibili all'autore dell'agente",
        "downloadChat": "Scarica chat",
        "pagePrivacyExplanationList": {
            "allConversations": "Tutte le conversazioni con questo agente sono visibili all'autore dell'agente",
            "anonymousUser": "Per utenti anonimi: l'autore vedrà il contenuto e l'indirizzo IP",
            "registeredUser": "Per utenti registrati: l'autore vedrà il contenuto e il nome utente",
            "contentAndUsername": "L'autore può vedere il contenuto, il tuo nome utente e il tuo indirizzo IP",
            "contentAndIpAddress": "L'autore può vedere il contenuto e il tuo indirizzo IP",
            "authorUsesInfo": "L'autore utilizza queste informazioni per migliorare le funzionalità dell'agente. Continuando, accetti queste condizioni."
        },
        "instructButton": "ISTRUISCIMI",
        "tryMeButton": "INIZIAMO",
        "resumeButton": "RIPRENDI",
        "chatHistory": "Cronologia chat",
        "chatHistoryDescription": "Mostra la cronologia chat con questo agente",
        "loadingChatHistory": "Caricamento cronologia chat...",
        "noChatHistoryAvailable": "Nessuna cronologia chat disponibile",
        "noResultsFound": "Nessun risultato trovato per \"{{searchText}}\"",
        "searchInChatHistory": "Cerca nella cronologia chat...",
        "latestFirst": "Più recenti prima",
        "oldestFirst": "Più vecchi prima",
        "exportChat": "Esporta Chat",
        "exportChatHistory": "Esporta la cronologia chat",
        "exportChatHistoryMessage": "Vuoi esportare la cronologia chat?",
        "chatBotButtonText": "CLICCA QUI PER APRIRE LA CHAT",
        "conversationStartedLabel": "Conversazione avvenuta il",
        "settingsHeaderLabel": "Configura qui se vuoi impostare una conversazione continua. Setta i secondi di silenzio prima dell'invio.",
        "continuousSpeechLabel": "Conversazione continua",
        "continuousSpeechDisabled": "Conversazione continua disabilitata poichè l'agente è in modalità muta",
        "holdToSpeak": "Tieni premuto per parlare",
        "releaseToEndListening": "Rilascia per smettere di parlare",
        "pressAndHoldToSpeak": "Premi e tieni premuto per parlare",
        "microphoneMode": "Modalità microfono",
        "hideEmissionsLabel": "Nascondi testo emesso dall'agente",
        "secondsLabel": "Secondi",
        "controlsPosition": "Posizione dei controlli",
        "avatarControls": "Controlli Avatar",
        "height": "Altezza",
        "depth": "Profondità",
        "avatarType": "Tipo Avatar",
        "blob": "Blob",
        "avatar3d": "Avatar 3D",
        "zoomed": "Vicino",
        "normal": "Normale",
        "far": "Lontano",
        "suggestions": "Usa le frecce per regolare l'altezza dell'avatar\nUsa +/- per regolare la profondità dell'avatar",
        "enablePositionControls": "Abilita controlli posizione",
        "tryMeHeaderLabel": "PROVA",
        "unknownPosition": "Posizione sconosciuta",
        "fieldPlace": "Indica la posizione (es 'Milano')",
        "showMapLinkFor": "Visualizza sulla mappa la posizione",
        "useMyPosition": "Usa la mia posizione",
        "myPosition": "Posizione corrente",
        "updatingPosition": "Aggiorno la posizione...",
        "placeNotFound": "Luogo sconosciuto!",
        "requirePositionHelp": "Per parlare con {{name}} devi decidere se fornire o meno la tua posizione. Questo perchè diverse risposte che potrà fornirti potrebbero dipendere da dove ti trovi.",
        "dontWantToProvidePosition": "Non voglio fornire la mia posizione",
        "attachmentsLabel": "Arricchisci il tuo messaggio",
        "iWantToTalkToIn": "Voglio parlare con {{name}} in",
        "message": "messaggio",
        "messages": "messaggi",
        "page": "Pagina {{current}} di {{total}}"
    },
    "artifact": {
        "close": "Chiudi",
        "size": "Dimensione",
        "generated": "Generato",
        "download": "Scarica",
        "print": "Stampa",
        "external": "Apri in una nuova finestra",
        "type": "Tipo",
        "fullscreen": "Schermo intero",
        "exitFullscreen": "Esci da schermo intero",
        "copy": "Copia",
        "generatedAt": "Generato il",
        "open": "Apri",
        "code": "Codice",
        "preview": "Anteprima",
        "copied": "Copiato!",
        "error": "Errore",
        "generatingPdf": "Generazione PDF...",
        "copying": "Copia in corso...",
        "moreCopyOptions": "Altre opzioni di copia",
        "copyAs": "Copia come",
        "downloadAsMarkdown": "Scarica come Markdown",
        "downloadRawMarkdownText": "Scarica testo markdown grezzo",
        "downloadAsPdf": "Scarica come PDF",
        "exportAsPdfDocument": "Esporta come documento PDF",
        "downloadAsHtml": "Scarica come HTML",
        "downloadFormattedHtml": "Scarica HTML formattato",
        "viewMode": "Modalità Visualizzazione",
        "codeMode": "Modalità Codice",
        "refresh": "Aggiorna",
        "share": "Condividi",
        "downloadAsJson": "Scarica come JSON",
        "downloadJsonData": "Scarica dati JSON",
        "downloadAsPng": "Scarica come PNG",
        "downloadPngImage": "Scarica immagine PNG",
        "downloadAsJpeg": "Scarica come JPEG",
        "downloadJpegImage": "Scarica immagine JPEG",
        "downloadAsGif": "Scarica come GIF",
        "downloadGifImage": "Scarica immagine GIF",
        "downloadAsWebp": "Scarica come WebP",
        "downloadWebpImage": "Scarica immagine WebP",
        "copyAsSvg": "Copia come SVG",
        "copySvgSourceCode": "Copia codice sorgente SVG",
        "copyAsPlainText": "Copia come testo normale",
        "copyAsText": "Copia come testo",
        "copyAsLanguage": "Copia come {{language}}",
        "copyLanguageCode": "Copia codice {{language}}",
        "copyWithoutSyntaxHighlighting": "Copia senza evidenziazione sintassi",
        "copyTextContent": "Copia contenuto testo",
        "pdfExportNotSupported": "L'esportazione PDF non è supportata in questo browser",
        "popupBlocked": "Popup bloccato! Abilita i popup per stampare.",
        "safariPdfInstructions": "Esportazione PDF aperta in una nuova finestra. Usa Cmd+P (Mac) o Ctrl+P (Windows) per stampare e salvare come PDF."
    },
    "media": {
        "title": "Titolo",
        "editAttributes": "Modifica attributi media",
        "uploadMimeTypeNotAllowed": "Il tipo di file non è permesso",
        "uploadSizeLimitMessage": "Il file caricato è troppo grande (max {{size}}MB)",
        "uploadWrongResolutionMessage": "La risoluzione deve essere {{width}}x{{height}} pixel",
        "memoriNameAlreadyUsed": "Hai già un Agente con questo nome",
        "uploadHelperImages": "Caricare un file con estensione png, jpg, jpeg o gif e con dimensione massima di {{size}}MB",
        "uploadHelper": "Caricare un file di dimensione massima di {{size}}MB",
        "uploadError": "Errore nel caricamento",
        "square": "quadrato",
        "scaleRatio": "Proporzioni",
        "addMediaLabel": "Aggiungi media",
        "insertThisMediaMsg": "Inserisci questi media",
        "mediaUploadMessage": "Clicca per caricare un nuovo media",
        "addLinkLabel": "Aggiungi un link",
        "linkKey": "URL",
        "linkValue": "Titolo link",
        "insertThisLink": "Inserisci un link a {{url}} con titolo {{title}}"
    },
    "upload": {
        "loginRequired": "Login richiesto",
        "pastedText": "testo-copiato",
        "uploadNotification": "Upload Fallito",
        "loginRequiredDescription": "Per caricare immagini, devi prima accedere",
        "uploadFiles": "Carica file ({{shortcut}}+O per aprire il selettore file)",
        "uploadFilesWithShortcut": "{{shortcut}}+O per aprire il selettore file",
        "uploadImages": "Carica immagini",
        "lastDocumentSlot": "Carica ultimo documento",
        "uploadDocuments": "Carica documenti",
        "maxDocumentsReached": "Puoi caricare fino a {{max}} documenti",
        "replace": "Sostituisci documento",
        "maxImagesReached": "Puoi caricare fino a {{max}} immagini",
        "apiClientNotConfigured": "Client API non configurato correttamente per il caricamento di media",
        "fileReadingFailed": "Lettura del file fallita",
        "uploadFailed": "Caricamento fallito",
        "uploadSuccess": "Caricamento riuscito",
        "remaining": "rimanenti",
        "maxReached": "Limite raggiunto",
        "titleImage": "Titolo immagine: {{title}}",
        "titleImageUpload": "Carica immagini",
        "titleHelp": "Aggiungi un titolo descrittivo per aiutare l'AI a fornire risposte più appropriate.",
        "titlePlaceholder": "Inserisci il titolo dell'immagine",
        "uploadSuccessDescription": "Il file è stato caricato con successo",
        "partialUpload": "Solo {{uploaded}} immagini su {{total}} immagini saranno caricate. Massimo {{max}} immagini consentite.",
        "cancel": "Annulla",
        "dragAndDropFiles": "Trascina qui i file per aggiungerli alla chat",
        "pasteMaxAttachmentsReached": "Massimo {{max}} allegati. Rimuovine uno per aggiungere questo come file.",
        "pasteContentTooLong": "Il testo incollato è troppo lungo (max {{size}}KB). Accorcialo o dividilo.",
        "pasteContentExceedsLimit": "Il contenuto incollato supera il limite di dimensione. Prova ad accorciare il testo o a dividerlo in parti più piccole.",
        "pasteAddedAsAttachment": "Testo incollato aggiunto come allegato",
        "filesNotAddedMaxAllowed": "{{count}} file non aggiunto/i (massimo {{max}} file consentiti).",
        "documentsNotAddedMaxAllowed": "{{count}} documento/i non aggiunto/i (massimo {{max}} file consentiti).",
        "imagesNotAddedMaxAllowed": "{{count}} immagine/i non aggiunta/e (massimo {{max}} file consentiti).",
        "documentsNotAddedContextSize": "{{count}} documento/i non aggiunto/i (limite dimensione contesto)."
    },
    "gamification": {
        "level": "Livello",
        "points": "punti",
        "memoriReachedLevel": "è diventato più evoluto ed ha raggiunto il livello",
        "levelGoToStatistics": "{{memori}} è al livello {{level}} con {{points}} punti. Clicca per andare alle statistiche.",
        "congratulationsNewLevel": "Congratulazioni, hai raggiunto un nuovo livello!",
        "congratulationsNewLevelDescription": "Il tuo agente è diventato più evoluto con {{points}} punti, guarda le",
        "statistics": "statistiche"
    },
    "login": {
        "login": "Accedi",
        "logout": "Esci",
        "userNameRequired": "Il nome utente è obbligatorio",
        "userName": "Nome utente",
        "userNamePlaceholder": "Inserisci il nome utente",
        "user": "Utente",
        "loggedDrawerTitle": "Ciao, {{name}}!",
        "loginDrawerTitle": "Accedi",
        "signupDrawerTitle": "Registrati",
        "newUserSignUp": "Sei un nuovo utente?",
        "signUp": "Registrati!",
        "alreadyHaveAnAccount": "Hai già un account?",
        "backToLogin": "Torna al login",
        "registrationDisabled": "La registrazione è disabilitata.",
        "contactAdmin": "Contatta l'amministratore per richiedere l'accesso",
        "userNameOrEmail": "Nome utente o email",
        "email": "Email",
        "emailFormatError": "Per favore, inserisci una mail valida",
        "username": "Nome utente",
        "usernameContainsReservedWord": "Il nome utente contiene una parola riservata, per favore cambia il nome utente",
        "usernameFormatError": "Il nome utente deve essere lungo almeno 3 caratteri e può contenere solo lettere, numeri e _",
        "otpCode": "Codice di verifica",
        "resendVerificationCode": "Invia di nuovo",
        "resentVerificationCode": "Codice di verifica inviato! Controlla la tua mail.",
        "welcomeTitle": "Bentornato",
        "welcomeDescription": "Inserisci il tuo codice di verifica a 4 cifre per continuare al tuo account",
        "otpTitle": "Inserisci il codice di verifica",
        "otpDescription": "Inserisci il codice a 4 cifre che hai generato nel tuo account",
        "otpStep1": "Clicca il pulsante qui sotto per aprire il tuo account",
        "otpStep2": "Genera un codice di verifica a 4 cifre (valido per 60 secondi)",
        "otpStep3": "Torna qui e inserisci il codice",
        "startOtpLogin": "Inizia verifica",
        "generateOtp": "Genera codice",
        "otpTimer": "Il codice scade tra {{seconds}} secondi",
        "otpInvalidFormat": "Inserisci un codice valido a 4 cifre",
        "otpInvalid": "Codice di verifica non valido",
        "otpError": "Errore nella validazione del codice. Riprova.",
        "otpSuccess": "Login effettuato con successo!",
        "otpEmailTitle": "Inserisci la tua email",
        "otpEmailDescription": "Inserisci il tuo indirizzo email per ricevere un codice di verifica",
        "otpCodeDescription": "Inserisci il codice a 4 cifre inviato a {{email}}",
        "emailPlaceholder": "Inserisci la tua email",
        "sendOtp": "Invia codice",
        "resendOtp": "Invia di nuovo",
        "resending": "Invio in corso...",
        "backToEmail": "Torna all'email",
        "otpSent": "Codice di verifica inviato!",
        "otpResent": "Codice reinviato con successo!",
        "otpSendError": "Errore nell'invio del codice. Riprova.",
        "emailRequired": "Email richiesta",
        "emailInvalid": "Inserisci un indirizzo email valido",
        "otpNotFound": "Codice di verifica non trovato",
        "otpExpired": "Il codice di verifica è scaduto",
        "otpMissing": "Il codice di verifica è richiesto",
        "otpSuccessMessage": "Verifica completata! Reindirizzamento...",
        "otpSuccessDescription": "Il tuo account è stato verificato con successo. Sarai reindirizzato a breve.",
        "otpHelp": "Inserisci il codice a 4 cifre dalla tua email",
        "emailHelp": "Ti invieremo un codice di verifica",
        "userFetchError": "Errore nel caricamento dei dati utente. Riprova.",
        "otpStep1Title": "Inserisci Email",
        "otpStep2Title": "Controlla Email",
        "otpStep3Title": "Inserisci Codice",
        "featureFast": "Veloce",
        "featureSecure": "Sicuro",
        "featureMobile": "Mobile",
        "quickActions": "Azioni rapide",
        "verified": "Verificato",
        "termsStatus": "Stato dei termini",
        "enabled": "Abilitato",
        "disabled": "Disabilitato",
        "advancedFeatures": "Funzionalità avanzate",
        "help": "Aiuto",
        "editProfile": "Modifica profilo",
        "notifications": "Notifiche",
        "logoutConfirm": "Sei sicuro di voler uscire?",
        "comingSoon": "Presto disponibile!",
        "accountOverview": "Panoramica account",
        "notSet": "Non impostato",
        "accepted": "Accettato",
        "password": "Password",
        "newPassword": "Nuova password",
        "confirmPassword": "Conferma la password",
        "currentPassword": "Password attuale",
        "passwordMatchingError": "Le password non coincidono.",
        "passwordFormatError": "La password deve essere lunga almeno 8 caratteri e contenere almeno un numero, una lettera maiuscola, una minuscola e un simbolo",
        "pwdWeak": "Debole",
        "pwdAcceptable": "Accettabile",
        "pwdStrong": "Forte",
        "mustChangePassword": "Devi cambiare la password",
        "passwordChange": "Cambio password",
        "emailChange": "Cambio email",
        "avatarChange": "Cambio avatar",
        "underage": "Devi avere almeno {{age}} anni per registrarti.",
        "optional": "opzionale",
        "birthDate": "Data di nascita",
        "birthDateHelper": "Ti chiediamo la data di nascita esclusivamente per abilitare o disabilitare le funzionalità che hanno restrizioni in base all'età",
        "missingData": "Informazioni mancanti",
        "missingDataHelper": "Sappiamo che questo è un po' fastidioso, ma abbiamo bisogno di alcune informazioni in più per completare la tua registrazione.",
        "goToAccountToChangeYourPreferences": "Puoi cambiare la tua scelta in qualsiasi momento dalla tua pagina Account.",
        "deepThoughtExplaination": "Pensiero Profondo è una funzionalità avanzata delle AI che ti consentirà di poter sfruttare a pieno le tue conversazioni mantenendo memoria delle stesse. Le AI con Pensiero Profondo possono darti informazioni adattandosi a te e alle cose che condividerete insieme. Consenti all'autore dell'agente di contattarti per offerte commerciali riguardanti prodotti su cui hai espresso interesse.",
        "tnCAndPPAcceptedHelper": "Dall'ultimo accesso, i T&C e l'Informativa sulla privacy sono stati modificati. Si prega di accettarle, altrimenti non sarà possibile apportare modifiche ai propri gemelli. Puoi sempre cancellare il tuo account nella pagina del tuo profilo utente.",
        "privacyLabel": "Ho letto e accettato l'",
        "privacyAndCookiePolicy": "informativa sui cookie e sulla privacy",
        "and": "e",
        "termsOfService": "i termini del servizio",
        "pAndCUAccepted": "Accetto le condizioni di utilizzo relative a Pensiero Profondo",
        "editAccount": "Modifica account",
        "save": "Salva",
        "successfullyLoggedIn": "{{username}} ha effettuato l'accesso con successo"
    },
    "chatLogs": {
        "atLeast": "Almeno {{count}} messaggi",
        "anyMessage": "Qualunque messaggio",
        "atLeast2": "Almeno 2 messaggi",
        "atLeast3": "Almeno 3 messaggi",
        "atLeast5": "Almeno 5 messaggi",
        "atLeast10": "Almeno 10 messaggi",
        "atLeast15": "Almeno 15 messaggi",
        "atLeast20": "Almeno 20 messaggi",
        "customMinimumMessages": "Personalizza il numero di messaggi"
    },
    "success": "Operazione andata a buon fine",
    "Error": "Errore",
    "internal server error": "Ops, scusa... qualcosa è andato storto nel server",
    "error": "Errore",
    "error.loading": "Errore durante il caricamento dei contenuti.",
    "error.notFound": "Ops, non abbiamo trovato ciò che cercavi.",
    "error.generic": "Ops, qualcosa è andato storto.",
    "error.serverNotResponding": "Stiamo facendo manutenzione o rilasciando aggiornamenti. Riprova più tardi.",
    "error.unprocessableEntity": "Errore durante il salvataggio dei dati. Ricontrolla i dati inseriti.",
    "error.goBackTo": "Prova a tornare alla",
    "error.reloadPage": "Ricarica la pagina",
    "error.tryAgain": "Riprova",
    "error.unauthorized": "Non sei autorizzato a visualizzare questo contenuto.",
    "errors": {
        "TENANT_NOT_FOUND": "Tenant non trovato",
        "TENANT_REGISTRATION_DISABLED": "La registrazione su questa piattaforma è disabilitata",
        "TENANT_MISSING_NAME": "Tenant: nome mancante",
        "TENANT_MAX_USERS_REACHED": "Numero massimo di utenti raggiunto",
        "TENANT_MAX_ADMINS_REACHED": "Numero massimo di utenti amministratori raggiunto",
        "TENANT_ALREADY_EXISTS": "Tenant già esistente",
        "TENANT_MISSING_DESCRIPTION": "Tenant: descrizione mancante",
        "TENANT_CANT_SET_COMPLETION_PROVIDER": "Tenant: non abilitato a gestire il provider di completamento",
        "TENANT_INVALID_TYPE": "Tenant: tipo non valido",
        "USER_NOT_CONFIRMED": "Utente ancora non confermato",
        "USER_NOT_FOUND": "Utente non trovato",
        "USER_OR_PASSWORD_INVALID": "Utente o password non validi",
        "USER_MUST_CHANGE_PASSWORD": "Devi cambiare la password",
        "USER_MUST_ENTER_VERIFICATION_CODE": "Devi inserire il codice di verifica",
        "USER_MISSING_TENANT": "Utente: tenant mancante",
        "USER_MISSING_NAME": "Utente: nome mancante",
        "USER_MISSING_PASSWORD": "Utente: password mancante",
        "USER_MISSING_EMAIL": "Utente: email mancante",
        "USER_MISSING_VERIFICATION_CODE": "Utente: codice di verifica mancante",
        "USER_NAME_ALREADY_USED": "Nome utente già in uso",
        "USER_PASSWORD_NOT_CONFORMING_TO_POLICY": "La password non rispetta le regole di sicurezza",
        "USER_EMAIL_ALREADY_USED": "Email già in uso",
        "USER_EMAIL_INVALID": "Email non valida",
        "USER_VERIFICATION_CODE_INVALID": "Codice di verifica non valido",
        "USER_MISSING_NAME_OR_EMAIL": "Nome utente o email mancante",
        "USER_NAME_INVALID": "Nome utente non valido",
        "USER_HAS_ONE_OR_MORE_MEMORI": "L'utente ha uno o più Agenti",
        "USER_MISSING_NEW_PASSWORD": "Utente: nuova password mancante",
        "USER_NOTHING_TO_DO": "Niente da fare",
        "USER_CANT_CREATE_MEMORI": "Utente non abilitato a creare Agenti",
        "USER_MAX_MEMORI_REACHED": "Massimo numero di Agenti raggiunto",
        "USER_TOO_MANY_ATTEMPTS": "Troppi tentativi",
        "USER_MUST_ACCEPT_TNC_AND_PP": "Devi accettare i termini e le condizioni",
        "USER_BIRTH_DATE_CANT_BE_CHANGED": "Data di nascita non può essere cambiata",
        "USER_CANT_SET_COMPLETION_PROVIDER": "Utente: non abilitato a gestire il provider di completamento",
        "USER_CANT_ENABLE_DEEP_THOUGHT": "Utente: non abilitato a gestire Pensiero Profondo",
        "USER_CANT_ENABLE_DCM_INTEGRATION": "Utente: non abilitato a gestire l'integrazione con DCM",
        "USER_CANT_ENABLE_CHAINING_OR_BOARD_OF_EXPERTS": "Utente: non abilitato a gestire la concatenazione o il gruppo di esperti",
        "USER_CREATION_BILLING_DENIED_PERMISSION": "Non hai crediti sufficienti per creare un agente",
        "USER_HAS_ONE_OR_MORE_COMPLETION_CONFIGS": "L'utente ha una o più configurazioni completions",
        "USER_CANT_BE_DELETED": "Utente non può essere cancellato",
        "USER_ORDER_BY_INVALID": "Ordine non valido",
        "MEMORI_NOT_FOUND": "Agente non trovato",
        "MEMORI_NOT_ACCESSIBLE": "Agente non accessibile",
        "MEMORI_ONLY_OWNER_CAN_CHANGE_GIVER_TAG_AND_PIN": "Solo il proprietario può cambiare il tag e il pin",
        "SESSION_NOT_FOUND": "Sessione non trovata",
        "SESSION_IS_NOT_ADMINISTRATIVE": "Sessione non amministrativa",
        "SESSION_EXPIRED": "Sessione scaduta",
        "SESSION_OTP_NOT_FOUND": "Codice di verifica non trovato",
        "SESSION_OTP_EXPIRED": "Il codice di verifica è scaduto",
        "SESSION_MISSING_TEMPORARY_TOKEN": "Il codice di verifica è richiesto",
        "MEMORI_MISSING_CONFIGURATION": "Agente: configurazione mancante",
        "MEMORI_CONFIGURATION_NOT_FOUND": "Agente: configurazione non trovata",
        "MEMORI_INVALID_PRIVACY_TYPE": "Agente: tipo di privacy non valido",
        "MEMORI_MISSING_PASSWORD": "Agente: password mancante",
        "MEMORI_INVALID_TOTAL_NUMBER_OF_RECOVERY_TOKENS": "Agente: numero totale di token di recupero non valido",
        "MEMORI_INVALID_MINIMUM_NUMBER_OF_RECOVERY_TOKENS": "Agente: numero minimo di token di recupero non valido",
        "MEMORI_INVALID_VOICE_TYPE": "Agente: tipo di voce non valido",
        "MEMORI_MISSING_NAME": "Agente: nome mancante",
        "MEMORI_MISSING_PASSWORD_OR_RECOVERY_TOKENS": "Agente: password o token di recupero mancanti",
        "MEMORI_INVALID_ID": "Agente: ID non valido",
        "MEMORI_NAME_ALREADY_USED": "Nome Agente già in uso",
        "MEMORI_INVALID_PIN": "Agente: PIN non valido",
        "MEMORI_GIVER_TAG_PIN_CHANGE_REQUIRES_SEPARATE_OPERATION": "Agente: cambio TAG e PIN richiedono operazioni separate",
        "MEMORI_NO_PASSWORD_WHEN_PUBLIC": "Agente: password non richiesta su agente pubblico",
        "MEMORI_DEEP_THOUGHT_REQUIRES_COMPLETIONS": "Pensiero Profondo richiede l'abilitazione delle completions",
        "MEMORI_BOARD_OF_EXPERTS_REQUIRES_COMPLETIONS": "Il gruppo di esperti richiede l'abilitazione delle completions",
        "MEMORI_INVALID_COMPLETION_CONFIG": "Agente: configurazione completions non valida",
        "MEMORI_MACRO_FUNCTIONS_REQUIRES_COMPLETIONS": "Macro funzioni richiede l'abilitazione delle completions",
        "MEMORI_BLOCKING_DATE_MISSING_OR_WRONG": "Agente: data di blocco mancante o non valida",
        "MEMORI_LIST_FILTER_NOT_SPECIFIED": "Agente: filtro non specificato",
        "MEMORI_TRANSFER_MISSING_DESTINATION_USER": "Trasferimento: utente di destinazione mancante",
        "MEMORI_TRANSFER_INVALID_DESTINATION_USER_ID": "Trasferimento: ID utente di destinazione non valido",
        "MEMORI_TRANSFER_DESTINATION_USER_DATA_INCONSISTENT": "Trasferimento: dati utente di destinazione non validi",
        "MEMORI_TRANSFER_NOTHING_TO_DO": "Trasferimento: alcuna operazione da fare",
        "MEMORI_CONFIGURATION_CANT_BE_CHANGED": "Agente: la configurazione non può essere modificata",
        "MEMORI_MISSING_NEW_PASSWORD": "Agente: nuova password mancante",
        "MEMORI_SESSIONS_INVALID_DATE_FROM_FORMAT": "Formato non valido data a partire da",
        "MEMORI_SESSIONS_INVALID_DATE_TO_FORMAT": "Formato non valido data fino a",
        "MEMORI_SESSION_NOT_FOUND": "Sessione non trovata",
        "MEMORI_SESSION_DOESNT_ACCEPT_MEDIA": "Sessione non accetta media",
        "MEMORI_FEATURE_REQUIRES_SUBSCRIPTION": "Agente: funzionalità richiede un abbonamento",
        "INTEGRATION_NOT_FOUND": "Integrazione non trovata",
        "INTEGRATION_INVALID_TYPE": "Tipo integrazione non valido",
        "INTEGRATION_ALREADY_EXISTS": "Integrazione già esistente",
        "INTEGRATION_MEMORI_IS_NOT_PUBLIC": "Agenti non pubblici non possono essere integrati",
        "INTEGRATION_MISSING_INVOCATION_TEXT": "Integrazione: testo di invocazione mancante",
        "INTEGRATION_MISSING_DEVICE_EMAILS": "Integrazione: email del dispositivo mancante",
        "INTEGRATION_MEMORI_IS_EMPTY": "Agenti vuoti non possono essere integrati",
        "INTEGRATION_MISSING_PRIVACY_POLICY": "Integrazione: privacy policy mancante",
        "INTEGRATION_MISSING_CATEGORY": "Categoria integrazione mancante",
        "INTEGRATION_MISSING_DESCRIPTION": "Descrizione integrazione mancante",
        "INTEGRATION_INVALID_INVOCATION_TEXT": "Testo di invocazione non valido",
        "INTEGRATION_GOOGLE_NO_MORE_AVAILABLE": "Google Home non più disponibile",
        "UPLOAD_REQUIRES_MULTIPART_ENCODING": "L'upload richiede l'encoding multipart",
        "UPLOAD_MISSING_CONTENT_TYPE_BOUNDARY": "Upload: manca il content type boundary",
        "UPLOAD_MAX_LENGTH_EXCEEDED": "Upload: dimensione massima superata",
        "UPLOAD_FILE_IS_EMPTY": "Upload: file vuoto",
        "UPLOAD_INVALID_FILE_TYPE_OR_SIGNATURE": "Upload: tipo di file o firma non validi",
        "UPLOAD_MISSING_FILE_NAME": "Upload: nome file mancante",
        "UPLOAD_INVALID_MEMORY_ID": "Upload: ID contenuto non valido",
        "UPLOAD_MISSING_FILE_CONTENT": "Upload: contenuto file mancante",
        "ASSET_NOT_FOUND": "Asset non trovato",
        "ASSET_NOT_ACCESSIBLE": "Asset non accessibile",
        "ASSET_MISSING_SESSION_ID": "Asset: ID sessione mancante",
        "ASSET_INVALID_FILE_NAME": "Asset: nome file non valido",
        "ASSET_MALWARE_SCAN_THREATS_FOUND": "Asset: la scansione ha trovato minaccia malware",
        "INVITATION_NOT_FOUND": "Invito non trovato",
        "INVITATION_NOT_ACCESSIBLE": "Invito non accessibile",
        "INVITATION_ALREADY_ACCEPTED": "Invito già accettato",
        "INVITATION_ALREADY_REJECTED": "Invito già rifiutato",
        "INVITATION_MISSING_DESTINATION_EMAIL": "Invito: email di destinazione mancante",
        "INVITATION_DESTINATION_EMAIL_INVALID": "Invito: email di destinazione non valida",
        "INVITATION_MISSING_TAG": "Invito: tag mancante",
        "INVITATION_MISSING_PIN": "Invito: PIN mancante",
        "INVITATION_INVALID_PIN": "Invito: PIN non valido",
        "INVITATION_INVALID_TYPE": "Invito: tipo non valido",
        "INVITATION_MISSING_DESTINATION_NAME": "Invito: nome destinatario mancante",
        "INVITATION_TAG_PIN_CANT_BE_CHANGED": "Invito: tag e pin non possono essere cambiati",
        "INVITATION_CANT_BE_CHANGED": "Invito: non può essere modificato",
        "ACTIONLOG_INVALID_USER_ID": "ID utente non valido",
        "ACTIONLOG_INVALID_DATE_FROM_FORMAT": "Data a partire da: formato non valido",
        "ACTIONLOG_INVALID_DATE_TO_FORMAT": "Data fino a: formato non valido",
        "ACTIONLOG_INVALID_MEMORI_ID": "ID agente non valido",
        "CONSUMPTIONLOG_INVALID_TYPE": "Tipo di log non valido",
        "CONSUMPTIONLOG_INVALID_DATE_FROM_FORMAT": "Data a partire da: formato non valido",
        "CONSUMPTIONLOG_INVALID_DATE_TO_FORMAT": "Data fino a: formato non valido",
        "CONSUMPTIONLOG_INVALID_USER_ID": "ID utente non valido",
        "CONSUMPTIONLOG_INVALID_MEMORI_ID": "Memori ID non valido",
        "NOTIFICATIONPREFS_INVALID_CHATLOG_EXTRACTION_PERIOD": "Notifiche: Periodo di estrazione chatlog non valido",
        "BROADCAST_NOT_ALLOWED": "Broadcast non consentito",
        "INVALID_NOTIFICATION_TYPE": "Tipo notifica non valido",
        "NOTIFICATION_NOT_FOUND": "Notifica non trovata",
        "INVALID_NOTIFICATION_FILTER": "Filtro notifica non valido",
        "INVALID_NOTIFICATION_PERIOD": "Periodo notifica non valido",
        "PROCESS_INVALID_TYPE": "Tipo di processo non valido",
        "PROCESS_ALREADY_RUNNING": "Processo già in esecuzione",
        "PROCESS_NOT_FOUND": "Processo non trovato",
        "IMPORTCSV_MISSING_ROWS": "Importazione CSV: righe mancanti",
        "IMPORTCSV_MISSING_CSV": "Importazione CSV: CSV mancante",
        "IMPORTCSV_MISSING_SEPARATOR": "Importazione CSV: separatore mancante",
        "IMPORTCSV_INVALID_SEPARATOR": "Importazione CSV: separatore non valido",
        "IMPORTCSV_MISSING_HEADERS": "Importazione CSV: intestazioni mancanti",
        "IMPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "Importazione CSV: separatore varianti titolo mancante",
        "IMPORTCSV_INVALID_RECEIVER_ID": "Importazione CSV: ID receiver non valido",
        "IMPORTCSV_INVALID_MEDIA_LINK": "Importazione CSV: link media non valido",
        "IMPORTCSV_INVALID_LINK_TITLE_HANDLING": "Importazione CSV: titolo link non valido",
        "IMPORTCSV_UNDETECTABLE_CHAR_ENCODING": "Importazione CSV: encoding caratteri non rilevabile",
        "IMPORTCSV_CANT_IMPORT_TO_SECRET_MEMORI": "Importazione CSV: impossibile importare in agenti segreti",
        "IMPORTTXT_MISSING_ROWS": "Importazione TXT: righe mancanti",
        "IMPORTTXT_INVALID_GRANULARITY": "Importazione TXT: granularità non valida",
        "IMPORTTXT_INVALID_RECEIVER_ID": "Importazione TXT: ID receiver non valido",
        "IMPORTTXT_INVALID_MEDIA_LINK": "Importazione TXT: link media non valido",
        "IMPORTTXT_INVALID_LINK_TITLE_HANDLING": "Importazione TXT: titolo link non valido",
        "IMPORTTXT_UNDETECTABLE_CHAR_ENCODING": "Importazione TXT: encoding caratteri non rilevabile",
        "IMPORTTXT_CANT_IMPORT_TO_SECRET_MEMORI": "Importazione TXT: impossibile importare in agenti segreti",
        "IMPORTTXT_IMPORT_LIMIT_EXCEEDED": "Importazione TXT: limite importazione superato",
        "IMPORTTXT_IMPORT_ON_GPT4_REQUIRES_API_KEY": "Importazione TXT: importazione su GPT-4 richiede API key",
        "IMPORTTXT_IMPORT_REQUIRES_PAYING": "Importazione TXT: importazione richiede un piano a pagamento",
        "IMPORTTXT_BILLING_DENIED_PERMISSION": "Importazione TXT: non hai crediti sufficienti per l'operazione",
        "IMPORT_MISSING_ROWS": "Importazione: righe mancanti",
        "IMPORT_CANT_IMPORT_TO_SECRET_MEMORI": "Importazione: impossibile importare in agenti segreti",
        "IMPORTMEMORI_INVALID_MEMORI_SPECS": "Importazione MEMORI: specifiche agente non valide",
        "IMPORT_MISSING_JSONL": "Importazione MEMORI: JSONL mancante",
        "IMPORTMEMORI_INVALID_SPECS": "Importazione MEMORI: specifiche non valide",
        "EXPORT_MISSING_PASSWORD": "Esportazione: password mancante",
        "EXPORTCSV_MISSING_CSV_SPECS": "Esportazione CSV: specifiche CSV mancanti",
        "EXPORTCSV_MISSING_SEPARATOR": "Esportazione CSV: separatore mancante",
        "EXPORTCSV_INVALID_SEPARATOR": "Esportazione CSV: separatore non valido",
        "EXPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "Esportazione CSV: separatore varianti titolo mancante",
        "EXPORTCSV_MISSING_NEW_LINE_CHAR": "Esportazione CSV: carattere di nuova riga mancante",
        "EXPORTCSV_INVALID_NEW_LINE_CHAR": "Esportazione CSV: carattere di nuova riga non valido",
        "EXPORTCSV_MISSING_PASSWORD": "Esportazione CSV: password mancante",
        "EXPORTJSONL_MISSING_JSONL_SPECS": "Esportazione JSONL: specifiche JSONL mancanti",
        "EXPORTJSONL_MISSING_PLATFORM": "Esportazione JSONL: piattaforma mancante",
        "EXPORTJSONL_INVALID_PLATFORM": "Esportazione JSONL: piattaforma non valida",
        "EXPORTJSONL_MISSING_PASSWORD": "Esportazione JSONL: password mancante",
        "EXPORTJSONL_EXPORT_REQUIRES_PAYING": "Esportazione JSONL: esportazione richiede un piano a pagamento",
        "ANALYSIS_MISSING_QUERY": "Analisi: query mancante",
        "ANALYSIS_CANT_ANALYZE_SECRET_MEMORI": "Analisi: impossibile analizzare agenti segreti",
        "ANALYSIS_USER_QUERY_MATCH_REQUIRES_DEEP_THOUGHT": "Analisi: corrispondenza query utente richiede Pensiero Profondo",
        "BADGE_ASSIGNMENT_WRONG_OR_MISSING_CREDENTIALS": "Assegnazione badge: credenziali errate o mancanti",
        "BADGE_ASSIGNMENT_MISSING_REF_ID": "Assegnazione badge: ID ref mancante",
        "BADGE_ASSIGNMENT_OUTCOME_NOT_FOUND": "Assegnazione badge: esito non trovato",
        "BADGE_ASSIGNMENT_MISSING_ASSERTION_URL": "Assegnazione badge: URL di asserzione mancante",
        "BADGE_ASSIGNMENT_MISSING_BADGE_URL": "Assegnazione badge: URL badge mancante",
        "BADGE_ASSIGNMENT_MISSING_ISSUER_URL": "Assegnazione badge: URL issuer mancante",
        "BADGE_ASSIGNMENT_INVALID_URL": "Assegnazione badge: URL non valido",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT": "Assegnazione badge: destinatario mancante",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_TYPE": "Assegnazione badge: tipo destinatario sconosciuto",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_IDENTITY": "Assegnazione badge: identità destinatario mancante",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_HASH_TYPE": "Assegnazione badge: tipo hash destinatario mancante",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_HASH_TYPE": "Assegnazione badge: tipo hash destinatario sconosciuto",
        "BADGE_ASSIGNMENT_WRONG_RECIPIENT_IDENTITY": "Assegnazione badge: identità destinatario errata",
        "BADGE_NOT_FOUND": "Badge non trovato",
        "OUTCOME_NO_DCM_CONFIGURED": "Outcome: nessun DCM configurato",
        "OUTCOME_USER_BADGES_DISABLED": "Outcome: badge utente disabilitati",
        "COMPLETION_CONFIG_MISSING_NAME": "Configurazione completions: nome mancante",
        "COMPLETION_CONFIG_MISSING_PROVIDER": "Configurazione completions: provider mancante",
        "COMPLETION_CONFIG_MISSING_ENDPOINT": "Configurazione completions: endpoint mancante",
        "COMPLETION_CONFIG_MISSING_API_KEY": "Configurazione completions: API key mancante",
        "COMPLETION_CONFIG_MISSING_MODEL": "Configurazione completions: modello mancante",
        "COMPLETION_CONFIG_NO_PURPOSE_SPECIFIED": "Configurazione completions: almeno un tipo di completions deve essere specificato",
        "COMPLETION_CONFIG_INVALID_NAME": "Configurazione completions: nome non valido",
        "COMPLETION_CONFIG_INVALID_PURPOSE": "Configurazione completions: tipo di completions non valido",
        "COMPLETION_CONFIG_INVALID_ENDPOINT": "Configurazione completions: endpoint non valido",
        "COMPLETION_CONFIG_INCONSISTENT_ENDPOINT": "Configurazione completions: endpoint incoerente",
        "COMPLETION_CONFIG_INVALID_PROVIDER": "Configurazione completions: provider non valido",
        "COMPLETION_CONFIG_NOT_FOUND": "Configurazione completions: non trovata",
        "COMPLETION_CONFIG_NOT_ACCESSIBLE": "Configurazione completions: non accessibile",
        "COMPLETION_CONFIG_NAME_RESERVED": "Configurazione completions: nome riservato",
        "COMPLETION_CONFIG_NAME_ALREADY_EXISTS": "Configurazione completions: nome già esistente",
        "COMPLETION_CONFIG_VISIBILITY_CHANGE_NOT_ALLOWED": "Configurazione completions: cambiamento visibilità non consentito",
        "COMPLETION_CONFIG_MISSING_MANDATORY_PREFIX": "Configurazione completions: prefisso obbligatorio mancante",
        "COMPLETION_CONFIG_VISIBILITY_NOT_PERMITTED": "Configurazione completions: visibilità non consentita",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_NOT_PERMITTED": "Configurazione completions: uso come default non consentito",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_REQUIRES_TENANT_VISIBILITY": "Configurazione completions: uso come default richiede visibilità tenant",
        "COMPLETION_CONFIG_CHARGEABLE_NOT_PERMITTED": "Configurazione completions: chargeable non consentito",
        "COMPLETION_CONFIG_INVALID_APPLY_TO": "Configurazione completions: apply to non valido",
        "COMPLETION_CONFIG_APPLY_TO_TENANT_NOT_ALLOWED": "Configurazione completions: apply to tenant non consentito",
        "TRUSTED_APPLICATION_NOT_FOUND": "Applicazione trusted non trovata",
        "TRUSTED_APPLICATION_NOT_ACCESSIBLE": "Applicazione trusted non accessibile",
        "TRUSTED_APPLICATION_NAME_REQUIRED": "Applicazione trusted: nome richiesto",
        "TRUSTED_APPLICATION_TOKEN_REQUIRED": "Applicazione trusted: token richiesto",
        "TRUSTED_APPLICATION_NAME_ALREADY_EXISTS": "Applicazione trusted: nome già esistente",
        "TRUSTED_APPLICATION_INVALID_TOKEN": "Applicazione trusted: token non valido"
    }
}
